import { jsPDF } from "jspdf";
import { TimeSpan } from "./timespan";
import autoTable from "jspdf-autotable";
import { ReportSummaryItem } from "../queries/models/report-summary-witem.model";
import Enumerable from "linq";
import { WorkInstanceType } from "../queries/models/enums/work-instance-type.enum";

export class InstallatorWorkTaskSummaryReportGenerator {
  _summarries: ReportSummaryItem[];

  constructor(summarries: ReportSummaryItem[]) {
    this._summarries = summarries;
  }

  public getPDFReport() {
    const doc = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      compress: false,
      format: "a4",
    });

    const users = Enumerable.from(this._summarries)
      .select((x) => ({ id: x.userId, name: x.username }))
      .distinct((x) => x.id)
      .toArray();

    // header
    const headerFontSize = 20;
    doc.setTextColor("#333333");
    doc.setFontSize(headerFontSize).setFont("", "bold");
    const headerText = `Summary of working hours for ${users.map((x) => x.name).join(", ")}`;
    doc.text(headerText, 10, 10, { maxWidth: 190 });
    const headerSize = doc.getTextDimensions(headerText, {
      maxWidth: 190,
      fontSize: headerFontSize,
    });

    // Table

    const totalWorkDuration = new TimeSpan(
      this._summarries
        .map((x) => x.workDurationTicks)
        .reduce((a, b) => a + b, 0)
    );
    autoTable(doc, {
      head: [
        ["Date", "Installation", "Installator", "Type", "Time", "Quantity"],
      ],
      startY: headerSize.h + 10,
      margin: {
        top: 10,
        left: 10,
        right: 10,
        bottom: 10,
      },
      columnStyles: { 4: { halign: "right" }, 5: { halign: "right" } },
      body: [...this._summarries]
        .sort((a, b) => +a.date - +b.date)
        .map((x) => [
          x.date.toLocaleDateString(),
          x.installationName,
          x.username,
          WorkInstanceType[x.workInstanceType],
          new TimeSpan(x.workDurationTicks).toHhMm(),
          new TimeSpan(x.workDurationTicks).totalHours.toFixed(2),
        ])
        .concat([
          [],
          [
            "Sum",
            "",
            "",
            "",
            totalWorkDuration.toHhMm(),
            totalWorkDuration.totalHours.toFixed(2),
          ],
        ]),
    });

    doc.save(`work-summary.pdf`);
  }
}
